import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  unassign: {
    color: "#f73d54"
  }
});
